import React from 'react'
import PermissionHOC from 'components/Permissions/PermissionHOC'
import { Label, Mandatory, WrapLabel } from './Styled'

const CustomLabel = (props) => {
    const { label, bold, fontSize, mandatory, className } = props

    return (
        <WrapLabel bold={bold} fontSize={fontSize} className={className}>
            <Label>
                {label}
                {mandatory && <Mandatory> *</Mandatory>}
            </Label>
        </WrapLabel>
    )
}

export default PermissionHOC(CustomLabel)